/**
 * Sidebar Menu Helper Functions
 *
 * Utility functions for rendering sidebar menu items with role-based access control
 */

import { Badge, Menu } from "antd";
import { Link } from "react-router-dom";
import IntlMessages from "utils/IntlMessages";

const { Item: MenuItem } = Menu;

/**
 * Render a simple menu item
 */
export const renderMenuItem = (key, path, icon, titleId, badge = null) => (
  <MenuItem key={key}>
    <Link to={path}>
      {icon}
      <span>
        <IntlMessages id={titleId} />
        {badge}
      </span>
    </Link>
  </MenuItem>
);

/**
 * @function renderMenuItemCustom
 * @description Render a menu item with custom content
 */
export const renderMenuItemCustom = (
  key,
  path,
  icon,
  content,
  badge = null,
) => (
  <MenuItem key={key}>
    <Link to={path}>
      {icon}
      <span>
        {content}
        {badge}
      </span>
    </Link>
  </MenuItem>
);

/**
 * @function createCountBadge
 * @description Create a badge for test status counts
 */
export const createCountBadge = (count) => {
  if (!count || count === 0) return null;

  return (
    <Badge
      count={count}
      style={{
        backgroundColor: "#52c41a",
        marginLeft: 8,
      }}
    />
  );
};

/**
 * Check if user has any of the specified roles
 */
export const hasAnyRole = (userRoles, ...rolesToCheck) => {
  return rolesToCheck.some((role) => userRoles.includes(role));
};

/**
 * Check if current role matches any of the specified roles
 */
export const isCurrentRole = (currentRole, ...rolesToCheck) => {
  return rolesToCheck.includes(currentRole);
};
